import * as GetIndexJuridicalPersonsTypes from 'src/actions/juridical-person/index/Types';
import { GetIndexJuridicalPersonsAction, } from 'src/actions/juridical-person/index/GetIndexJuridicalPersons.actions';
import JuridicalPerson from 'src/entities/JuridicalPerson';

export interface GetIndexJuridicalPersonsState {
  juridicalPersons: JuridicalPerson[];
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetIndexJuridicalPersonsState = {
  loading: false,
  error: false,
  errorMessage: {},
  juridicalPersons: []
};

export function GetIndexJuridicalPersonsReducer(
  state: GetIndexJuridicalPersonsState = initialState,
  action: GetIndexJuridicalPersonsAction
): GetIndexJuridicalPersonsState {

  switch (action.type) {
    case GetIndexJuridicalPersonsTypes.GET_INDEX_JURIDICAL_PERSONS_ATTEMPT:
      return {...state, juridicalPersons: [], loading: true, error: false};
    case GetIndexJuridicalPersonsTypes.GET_INDEX_JURIDICAL_PERSONS_SUCCESS:
      return {
        ...state,
        juridicalPersons: action.payload,
        loading: false,
        error: false
      };
    case GetIndexJuridicalPersonsTypes.GET_INDEX_JURIDICAL_PERSONS_FAILURE:
      return {...state, juridicalPersons: [], loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/juridical-person/GetIndexJuridicalPersonReducer.tsx